import { render, staticRenderFns } from "./LocalityConfig.vue?vue&type=template&id=c2250c32"
import script from "./LocalityConfig.vue?vue&type=script&lang=js"
export * from "./LocalityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports